import { render, staticRenderFns } from "./HabilitarSinistro.vue?vue&type=template&id=fa9f7502&scoped=true"
import script from "./HabilitarSinistro.vue?vue&type=script&lang=js"
export * from "./HabilitarSinistro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9f7502",
  null
  
)

export default component.exports